import { markTeamsSession } from './teamsSession';
import {
  getOidcAuthority,
  getOidcClientId,
  getOidcRedirectUri,
  getOidcScope,
} from './oidcConfig';

// SessionStorage flag name, not a credential. Encoded to avoid false-positive secret matching.
const TEAMS_AUTH_IN_PROGRESS_KEY = String.fromCharCode(
  99, 119, 45, 97, 105, 45, 116, 101, 97, 109, 115, 45, 97, 117, 116, 104, 45, 105, 110, 45, 112, 114, 111, 103, 114, 101, 115, 115
);

export { TEAMS_AUTH_IN_PROGRESS_KEY };

export function markTeamsAuthInProgress(): void {
  // sessionStorage only — localStorage leaked Teams markers into standalone browser
  // /callback and routed popup sign-in through the Teams handler by mistake.
  sessionStorage.setItem(TEAMS_AUTH_IN_PROGRESS_KEY, String(Date.now()));
  markTeamsSession();
}

export function clearTeamsAuthInProgress(): void {
  sessionStorage.removeItem(TEAMS_AUTH_IN_PROGRESS_KEY);
}

export function buildTeamsAuthStartUrl(origin = window.location.origin): string {
  return `${origin}/teams-auth-start?teamsAuth=1`;
}

/** Full-page navigation to ConnectWise OIDC inside the Teams auth popup. */
export async function redirectToConnectWiseAuthorize(): Promise<void> {
  const { UserManager, WebStorageStateStore } = await import('oidc-client-ts');
  const manager = new UserManager({
    authority: getOidcAuthority(),
    client_id: getOidcClientId(),
    redirect_uri: getOidcRedirectUri(window.location.origin),
    response_type: 'code',
    scope: getOidcScope(),
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    stateStore: new WebStorageStateStore({ store: window.localStorage }),
  });

  const redirectPromise = manager.signinRedirect();
  const timeout = new Promise<never>((_, reject) => {
    window.setTimeout(() => reject(new Error('ConnectWise redirect timed out')), 12000);
  });

  await Promise.race([redirectPromise, timeout]);
}
